import * as Client from '../clients/GetDiscountCodes';
import type { IDiscountCode } from '../types/DiscountCode.types';

/**
 * Unwraps the `appliedCodes` envelope so consumers deal in a plain list, and
 * tolerates a missing array (a code-history read must never blow up the
 * Payment Information page over a shape surprise).
 */
export const getDiscountCodes = async (): Promise<IDiscountCode[]> => {
  const response = await Client.getDiscountCodes();

  return response?.appliedCodes ?? [];
};
